import React from 'react';
import StatisticsPage from '../components/supplierStats/StatisticsPage';
export default function SupplierStatsList() {
  return <StatisticsPage kind="brands" />;
}
